
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:630px;">
    <form #orderForm="ngForm">
      <div class="modal-header">
        <h4 class="modal-title">Import K2 Groups</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="k2GroupsFiltered.length" (onChange)="onListControlsChange($event)"></list-controls>
        <table class="table table-striped">
          <thead>
            <tr>
              <th></th>
              <th>Area</th>
              <th>Group</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of k2GroupsToShow">
              <td>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="g.selected" name="group-selection-checkbox-{{g.index}}" (change)="updateSelection(g.index)">
                </div>
              </td>
              <td>{{ g.areaName }}</td>
              <td>{{ g.groupName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <p>Selected {{this.selectedCount}} of {{this.k2Groups.length}} groups</p>
        <div class="dropdown">
          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0);" (click)="importGroups()">Import all selected groups</a><a class="dropdown-item" href="javascript:void(0);" (click)="selectAll()">Select all</a><a class="dropdown-item" href="javascript:void(0);" (click)="deselectAll()">Deselect all</a><a class="dropdown-item" href="javascript:void(0);" (click)="cancel()">Cancel</a></div>
        </div>
      </div>
    </form>
  </div>
</div>